import { POST, GET } from 'src/api/apiHandler';
import { message } from 'src/design-system/components/atoms';
import i18n from 'src/i18n';
import {
  FETCH_JOINING_BONUS_PROGRAMS,
  FETCH_JOINING_BONUS_PROGRAM_BY_ID,
  ADD_JOINING_BONUS_PROGRAM,
  UPDATE_JOINING_BONUS_PROGRAM,
  DISABLE_JOINING_BONUS_PROGRAM,
  DOWNLOAD_JOINING_BONUS_PROGRAMS,
  JOINING_BONUS_PROGRAM_SAMPLE_XLSX,
  BULK_ADD_JOINING_BONUS_PROGRAMS,
} from 'src/api/routes';
import { API_BASE_URL } from 'src/globals';
import {
  IFetchProgramsRequest,
  IAddJoiningBonusProgramRequest,
  IUpdateProgramRequest,
} from './ReferralProgram.types';

export const fetchJoiningBonusPrograms = async (
  body: IFetchProgramsRequest,
) => {
  return POST(`${API_BASE_URL}${FETCH_JOINING_BONUS_PROGRAMS}`, body);
};

export const fetchJoiningBonusProgramById = async (id: number) => {
  return POST(`${API_BASE_URL}${FETCH_JOINING_BONUS_PROGRAM_BY_ID}`, { id });
};

export const addJoiningBonusProgram = async (
  body: IAddJoiningBonusProgramRequest,
) => {
  return POST(`${API_BASE_URL}${ADD_JOINING_BONUS_PROGRAM}`, body);
};

export const updateJoiningBonusProgram = async (
  body: IUpdateProgramRequest,
) => {
  return POST(`${API_BASE_URL}${UPDATE_JOINING_BONUS_PROGRAM}`, body);
};

export const disableJoiningBonusProgram = async (id: number) => {
  return POST(`${API_BASE_URL}${DISABLE_JOINING_BONUS_PROGRAM}`, { id });
};

export const downloadJoiningBonusPrograms = async () => {
  return GET(
    `${API_BASE_URL}${DOWNLOAD_JOINING_BONUS_PROGRAMS}`,
    undefined,
    'blob',
  );
};

export const downloadJoiningBonusProgramSampleXlsx = async () => {
  return GET(
    `${API_BASE_URL}${JOINING_BONUS_PROGRAM_SAMPLE_XLSX}`,
    undefined,
    'blob',
  );
};

export const bulkAddJoiningBonusPrograms = async (
  programs: IAddJoiningBonusProgramRequest[],
) => {
  return POST(`${API_BASE_URL}${BULK_ADD_JOINING_BONUS_PROGRAMS}`, {
    programs,
  });
};

export const bulkAddJoiningBonusProgramsBatch = async (body: {
  programs: IAddJoiningBonusProgramRequest[];
}) => {
  const result = await POST(
    `${API_BASE_URL}${BULK_ADD_JOINING_BONUS_PROGRAMS}`,
    body,
  );
  if (!result.isSuccess) {
    message.error(
      result.errorMessage || result.errData || i18n.t('bulk_operation_failed'),
    );
  }
  return result;
};
